
<iframe [style.height]="innerHeight" id="CertificatesIframe" style="width: 100%" [src]="certurl | safe" title="Invoice Certificates"></iframe>
